/// <amd-module name="Artifacts/Package/components/package-details-common/PackagePerson" />
import { CiConstants } from "Artifacts/Root/Constants";
import { CustomerIntelligenceHelper } from "Artifacts/Root/helpers/CustomerIntelligenceHelper";
import { htmlEncode } from "Artifacts/Root/helpers/HtmlHelper";
import { isSafeProtocol } from "Artifacts/Root/helpers/UrlHelper";
import * as RootRes from "Artifacts/Root/Resources";
import { IPerson } from "Artifacts/Root/types/IPerson";
import * as React from "react";
import * as Utils_String from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { Icon } from "VSSUI/Icon";

export interface IPersonProps {
  pageContext: IVssPageContext;
  person: IPerson;
}

export class PackagePerson extends React.PureComponent<IPersonProps> {
  public render(): JSX.Element {
    if (!this.props.person) {
      <div />;
    }

    const isUrlSafe =
      this.props.person.url &&
      (isSafeProtocol(this.props.person.url) || this.props.person.url.indexOf(":") === -1);
    const additionalInfo = this.props.person.email || isUrlSafe;

    return (
      <div className={"person package-attribute-item" + (additionalInfo ? " additional-info" : "")}>
        <div>
          <Icon className={"package-attribute-item-icon"} iconName="Contact" />
          {this.props.person.name}
        </div>
        {additionalInfo && (
          <div className="person-hover">
            {this.props.person.email && (
              <a
                className="person-email"
                href={"mailto:" + htmlEncode(this.props.person.email)}
                rel="noopener noreferrer"
                onClick={() => this._registerLinkClick(CiConstants.PersonEmailLinkClicked)}
                aria-label={Utils_String.format("{0}: {1}", RootRes.Email, this.props.person.email)}
              >
                <span>
                  <Icon className="package-attribute-item-inline-icon" iconName="Mail" />
                  {RootRes.Email}
                </span>
              </a>
            )}
            {isUrlSafe && (
              <a
                className="person-url"
                href={htmlEncode(this.props.person.url)}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => this._registerLinkClick(CiConstants.PersonUrlLinkClicked)}
                aria-label={Utils_String.format("{0}: {1}", RootRes.Website, this.props.person.url)}
              >
                <Icon iconName="Globe" />
                <span>{RootRes.Website}</span>
              </a>
            )}
          </div>
        )}
      </div>
    );
  }

  private _registerLinkClick(feature: string) {
    CustomerIntelligenceHelper.publishEvent(this.props.pageContext, feature);
  }
}
